export default __webpack_public_path__ + "static/media/cafe.759c63db.png";